
import React, { Suspense, lazy } from 'react';
import ErrorBoundary from './Routing/ErrorBoundary';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../src/services/AuthContext';

const RoutingPage = lazy(() => import('./Routing/RoutingPage'));

function App() {
   
    const basePath = window.location.pathname.includes("/ClaimMatrix_test1") ? "/ClaimMatrix_test1" : "";
    return (
        <BrowserRouter basename={basePath}>
            <AuthProvider> 
                <div>
                    <ErrorBoundary>
                        <Suspense fallback={<div>Loading...</div>}>
                            <RoutingPage />
                        </Suspense>
                    </ErrorBoundary>
                </div>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;



